export default __webpack_public_path__ + "static/media/copilot.d5007a95.jpg";